import {PushNotifications} from '@capacitor/push-notifications'

export default {
    /**
     * Fetches the push token once per call. Listeners are removed after the first
     * registration or registrationError — repeated login/register must not stack
     * listeners or each register() will invoke every prior callback (Capacitor).
     */
    getDeviceToken(successCallback, errorCallback){
        return new Promise((resolve)=>{
            (async ()=>{
                let registrationHandle;
                let errorHandle;
                let settled = false;

                const cleanup = async ()=>{
                    await Promise.all([
                        registrationHandle ? registrationHandle.remove().catch(()=>{}) : Promise.resolve(),
                        errorHandle ? errorHandle.remove().catch(()=>{}) : Promise.resolve(),
                    ]);
                };

                try{
                    const permission = await PushNotifications.requestPermissions();
                    if (permission.receive !== 'granted'){
                        errorCallback('NOT_GRANTED');
                        resolve();
                        return;
                    }

                    registrationHandle = await PushNotifications.addListener('registration', async (token)=>{
                        if (settled){
                            return;
                        }
                        settled = true;
                        await cleanup();
                        const payload = {token: token.value};
                        successCallback(payload);
                        resolve(payload);
                    });

                    errorHandle = await PushNotifications.addListener('registrationError', async (error)=>{
                        if (settled){
                            return;
                        }
                        settled = true;
                        await cleanup();
                        errorCallback(error);
                        resolve();
                    });

                    await PushNotifications.register();
                }catch (err){
                    await cleanup();
                    errorCallback(err);
                    resolve();
                }
            })();
        });
    },
}
